import { useContext } from 'react'
import { ProviderAuthContext, type ProviderAuthContextType } from './ProviderAuthContext'

export function useProviderAuth(): ProviderAuthContextType {
  const context = useContext(ProviderAuthContext)
  if (!context) {
    throw new Error('useProviderAuth must be used within a ProviderAuthProvider')
  }
  return context
}
